// src/components/StoreMapControl.js
import React from 'react';
import StorePlantEditor from './StorePlantEditor';

export default function StoreMapControl({ clienteId, focusSectionRef = null, focusSectionName = null, focusSource = null }) {
  return (
    <StorePlantEditor
      clienteId={clienteId}
      focusSectionRef={focusSectionRef}
      focusSectionName={focusSectionName}
      focusSource={focusSource}
    />
  );
}
